import React from 'react';
import { List, Segment, Header, Grid, } from 'semantic-ui-react';
import axios from 'axios';
import {FormattedMessage} from "react-intl";

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


export default class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            facultyId: '',
            faculties: [],
            facultyData: [],
            unsaData: [],
            uticData: [],
            spusData: [],
            facultyName: '',
        };
        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        // window.localStorage.clear();
            this.getData();
    }

    getData() {
        if(localStorage.getItem('activeRole').substr(0, 8) !== 'Ministar') {
            axios.get('additional-information/important-contacts')
                .then(res => {
                    const resData = res.data;
                    const facultyData = resData[0].facultyContact.sort((a, b) => a.contactType < b.contactType);
                    const facultyName = resData[0].facultyName;
                    // const unsaData = resData.unsaContact;
                    this.setState({facultyData, facultyName});
                })
                .catch(err => {
                    this.setState({error: true});
                    console.log('Failed to fetch contact results');
                });
        }

        const uticData = [
            {
                contactType: 'telefon',
                value: '+387 33 560 240'
            },
            // {
            //     contactType: 'fax',
            //     value: '0038733213773'
            // },
            {
                contactType: 'e-mail',
                value: 'eunsa@unsa.ba'
            },
            {
                contactType: 'web stranica',
                value: 'http://www.utic.unsa.ba'
            }

        ];

        const unsaData = [
            {
                contactType: 'telefon',
                value: '+387 33 565 119'
            },
            {
                contactType: 'e-mail',
                value: 'nastava@unsa.ba'
            },
            {
                contactType: 'web stranica',
                value: 'http://www.unsa.ba'
            }

        ];
        this.setState({ uticData, unsaData });
    }


    render() {
        return (
            <div>

                <Header as="h1">{ <FormattedMessage id="common.contact" />}</Header>

                <Grid columns={(localStorage.getItem('activeRole').substr(0, 8) !== 'Ministar' && (localStorage.getItem('activeRole').substr(0, 40) !== 'Služba za zapošljavanje Kantona Sarajevo' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' ) && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja')) ? '3' : '2'} centered className="stackable">
                    <Grid.Row stretched>
                        {(localStorage.getItem('activeRole').substr(0, 8) !== 'Ministar' && (localStorage.getItem('activeRole').substr(0, 40) !== 'Služba za zapošljavanje Kantona Sarajevo') && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' ) && <Grid.Column>
                            <SegmentContact
                                data={this.state.facultyData}
                                name={this.state.facultyName}
                            />
                        </Grid.Column>}
                        <Grid.Column>
                            <SegmentContact
                                data={this.state.unsaData}
                                name="UNSA"
                            />
                        </Grid.Column>
                        <Grid.Column>
                            <SegmentContact
                                data={this.state.uticData}
                                name="UTIC"
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

class SegmentContact extends React.Component {
    render() {
        return (
            <Segment.Group clearing style={{ backgroundColor: 'white' }}>
                <Segment color="blue">
                    <Header as="h3">{this.props.name}</Header>
                </Segment>

                <Segment>
                    {this.props.data.map((el) =>
                        (<List>
                            <List.Item>
                                { el.contactType === 'telefon' ? <List.Icon name="phone" />
                                    : ( el.contactType === 'e-mail' || el.contactType === 'primarni e-mail') ? <List.Icon name="mail" />
                                        : el.contactType === 'fax' ? <List.Icon name="fa-fax" />
                                            : <List.Icon name="world" />}
                                { el.contactType === 'web stranica' ? <List.Content><a href={el.value}>{el.value}</a></List.Content>
                                    : <List.Content>{el.value}</List.Content>}
                            </List.Item>
                        </List>))}
                </Segment>
            </Segment.Group>);
    }
}



// WEBPACK FOOTER //
// ./src/views/Contact/Contact.js